import { Box, Button, DialogActions, DialogContent, DialogContentText, Stack, TextField, Typography } from '@mui/material'
import { ReactComponent as IconCTH } from 'assets/icons/IconCTH.svg'
import { ReactComponent as IconKeyboard } from 'assets/icons/IconKeyboard.svg'
import { TooltipCC } from 'components/common'
import { IconInfomation } from 'components/common/IconCommon'
import { NS_TRANS } from 'constants/common'
import { useMenuCC } from 'hooks'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import theme, { color } from 'theme'
import PopoverCC from './PopoverCC'
import NoPermissionCTH from 'assets/img/NoPermissionCTH.png'
import { FUNCTIONS } from 'constants/roles'
import useMeetingCC from 'hooks/useMeetingCC'
import { useSelector } from 'react-redux'
import { checkFunctionHaveCode } from 'store/user/functions'
import { selectCurrentUserFunctions } from 'store/selectors'
import { validateRoomId } from 'utils/validates'

const SIP_ERROR_CODES = [
    'SIP_USER_REQUIRED',
    'SIP_USER_INVALID',
    'SIP_CALL_NOT_ALLOWED',
    'SIP_ACCOUNT_NOT_ASSIGNED',
    'SIP_CALLED_ROOM_DISABLED',
    'CONCURRENT_MEETING_LIMIT_REACHED',
    'INSTANT_MEETING_REQUIRES_APPROVAL',
    'POPUP_BLOCKED',
    'CALLED_ROOM_REQUEST_FAILED'
]

const popoverInfoC = {
    cth: {
        title: 'popover.titleCTH',
        content: 'popover.contentCTH',
        info: 'popover.infoCTH',
        placeholder: 'popover.placeholderCTH',
        btnTitle: 'popover.btnJoinCTH',
        btnOpen: 'mnMeeting.cth',
        btnOpenIcon: <IconCTH />
    },
    meet: {
        title: 'popover.titleMeet',
        content: 'popover.contentMeet',
        info: 'popover.infoMeet',
        placeholder: 'popover.placeholderMeet',
        btnTitle: 'popover.btnJoinMeet',
        btnOpen: 'mnMeeting.joinId',
        btnOpenIcon: <IconKeyboard />
    }
}

const MeetingPopoverForm = ({ type, t, open, setAnchorEl }) => {
    const { handleJoinID, isJoining, joinError, clearJoinError } = useMeetingCC()
    const [roomId, setRoomId] = useState('')

    useEffect(() => {
        if (open) {
            setRoomId('')
            clearJoinError()
        }
    }, [open, clearJoinError])

    const isValid = validateRoomId(roomId, type)
    const errorCode = SIP_ERROR_CODES.includes(joinError) ? joinError : 'CALLED_ROOM_REQUEST_FAILED'
    const handleJoin = async() => {
        if (!isValid || isJoining) return
        const succeeded = await handleJoinID(type, roomId, setAnchorEl)
        if (succeeded) setRoomId('')
    }

    const handleChangeRoomID = (e) => {
        setRoomId(e.target.value)
        clearJoinError()
    }

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    {t(popoverInfoC[type].content)} <TooltipCC title={t(popoverInfoC[type].info)}>
                        <span>
                            <IconInfomation style={{ cursor: 'pointer' }} />
                        </span>
                    </TooltipCC>
                </DialogContentText>
                <TextField autoFocus fullWidth placeholder={t(popoverInfoC[type].placeholder)} value={roomId} onChange={handleChangeRoomID} onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault()
                        handleJoin()
                    }
                }} sx={{ marginTop: theme.spacing(0.5) }} />
                {joinError && <Typography role="alert">{t(`${NS_TRANS.MANAGE_MEETING}:sipCalledRoom.errors.${errorCode}`)}</Typography>}
            </DialogContent>
            <DialogActions>
                <Button aria-busy={isJoining} disabled={!isValid || isJoining} onClick={handleJoin} sx={{ width: 1 }}>{t(popoverInfoC[type].btnTitle)}</Button>
            </DialogActions>
        </>
    )
}

const PopoverMeetingCC = ({ type = 'meet', alawaysShow = false }) => {
    const { t } = useTranslation([NS_TRANS.MANAGE_MEETING])
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const functions = useSelector(selectCurrentUserFunctions)

    // Kiểm tra quyền gọi SIP - Trước 3/5/2024
    // useEffect(() => {
    //     if (type === 'cth') {
    //         async function fetchPeopleSearch() {
    //             try {
    //                 const resp = await apiSip.getPeopleSearchPermission();
    //                 setIsHaveSipPermission(true);
    //             } catch (e) {
    //                 setIsHaveSipPermission(false);
    //             }
    //         }
    //         fetchPeopleSearch();
    //     }
    // }, [type])

    // chungnm2 check roomId exist

    const handleOpenPopover = (e) => {
        setAnchorEl(e.currentTarget)
    }

    /**
     * Kiểm tra quyền gọi SIP - isHaveSipPermission
     * 3/5/2024 - Apply role
     * Chỉ kiểm tra người dùng có chức năng gọi CTH - checkFunctionHaveCode
     */
    if (!checkFunctionHaveCode(functions, FUNCTIONS.MANAGE_CALL_SIP) && type==="cth") {
        return (
            <React.Fragment>
                <Button onClick={handleOpenPopover} variant='outlined' sx={{ display: { xs: alawaysShow ? 'flex' : 'none', lg: 'flex' } }} startIcon={popoverInfoC[type].btnOpenIcon}>{t(popoverInfoC[type].btnOpen, { ns: NS_TRANS.BTN })}</Button>
                <PopoverCC title={t(popoverInfoC[type].title)} open={open} setAnchorEl={setAnchorEl} anchorEl={anchorEl} >
                    <DialogContent sx={{ maxWidth: 'unset !important', pb: 5 }}>
                        <DialogContentText sx={{ color: color.default }}>
                            <Stack>
                                <Box display={'flex'} alignItems={'end'} justifyContent={'space-between'} mb={2}>
                                    <Box>
                                        <Typography color={color.default}>{t('meeting.sip.notPermission', { ns: NS_TRANS.MAIN })}</Typography>
                                        <Typography color={color.default}>{t('meeting.sip.contactForPermission', { ns: NS_TRANS.MAIN })}</Typography>
                                    </Box>
                                    <img src={NoPermissionCTH} width={100} height={80} alt='no-permission' />
                                </Box>
                                <Box>
                                    <Typography color={color.default} whiteSpace={'nowrap'} paddingLeft={4}><span style={{ width: '130px', display: 'inline-block' }}>Phạm Hồng Sơn</span> <span style={{ padding: '0 4px', fontWeight: '600' }}>0966.389.332</span> sonph21@viettel.com.vn</Typography>
                                </Box>
                            </Stack>
                </DialogContentText>
            </DialogContent>
        </PopoverCC>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Button className={anchorEl ? 'show-arrow' : ''} onClick={handleOpenPopover} variant='outlined' sx={{ display: { xs: alawaysShow ? 'flex' : 'none', lg: 'flex' } }} startIcon={popoverInfoC[type].btnOpenIcon}>{t(popoverInfoC[type].btnOpen, { ns: NS_TRANS.BTN })}</Button>
            <PopoverCC title={t(popoverInfoC[type].title)} open={open} setAnchorEl={setAnchorEl} anchorEl={anchorEl} >
                <MeetingPopoverForm type={type} t={t} open={open} setAnchorEl={setAnchorEl} />
            </PopoverCC>
        </React.Fragment>
    )
}

export default PopoverMeetingCC
